import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from './screens/Home/Home'
import AboutPublisher from './screens/About'
import Contact from './screens/Contact'
import Price from './screens/Price/Price'
import HowWork from './screens/HowWorks/HowWork'
import Footer from "./components/Footer";
import CaseStudies from "./screens/case/CaseStudies";
import Privacy from "./screens/privacy";
import Terms_Condition from "./screens/terms_condition";


function App() {
  return (
    <div className="App">
      <Router>
      <Header/>
        <Routes>
          <Route element = {<Home></Home>} path="/"/>
          <Route element = {<CaseStudies></CaseStudies>} path="/case-studies"/>
          <Route element = {< AboutPublisher></ AboutPublisher>} path="/about"/>
          <Route element = {<Contact></Contact>} path="/contact"/>
          <Route element ={<Price></Price>} path="/price"/>
          <Route element = {<HowWork></HowWork>} path="/howworks"/>
          <Route element = {<Privacy></Privacy>} path="/privacy"/>
           <Route element = {<Terms_Condition></Terms_Condition>} path="/terms-condition"/>
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
